import {
  WS_CONDITION_CHANGING,
  WS_CONDITION_HOVER,
  WS_CONDITION_PRELOADED,
} from '@pages/WorkSchedule/constants/cellConditions';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const clearAllHoverStyles: NWorkSchedule.ClearAllHoverStyles = ({
  hoveredCells,
}) => {
  (hoveredCells?.current || []).forEach((className: string) => {
    const cell = document.querySelector(className);
    const timeRangeContainer = cell?.querySelector('.time-range-container');
    const isPreloaded = cell?.classList?.contains(WS_CONDITION_PRELOADED);
    const isChanging = cell?.classList?.contains(WS_CONDITION_CHANGING);

    if (timeRangeContainer && !isPreloaded && !isChanging) {
      timeRangeContainer.textContent = '';
    }

    return cell?.classList.remove(WS_CONDITION_HOVER);
  });

  return (hoveredCells.current = []);
};
